import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { RolesPermissionsTable } from "Components/Admin/RolesPermissionsTable";
import { Resources, useResource } from "Translations/Resources";

export default function RolesPermissionsPage() {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.Pages.Titles.RolesPermissions)}>
      <StyledPageWrapper maxWidth="unset !important">
        <RolesPermissionsTable />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
}
